import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "pwd_reissue_request"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = {
    key: 0,
    class: "err"
};
const _hoisted_6 = { class: "recap" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { class: "bt_box" };
const _hoisted_9 = ["disabled"];
import { ref, watch } from 'vue';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import RecaptchaForm from '@component/RecaptchaForm.vue';
import Alert from '@util/BrowserAlert';
import InertiaUtil from '@util/InertiaUtil';
export default /*@__PURE__*/ _defineComponent({
    __name: 'pwd_reissue_request',
    props: {
        common: {},
        errors: {},
        forgot_password_success: {}
    },
    setup(__props) {
        const props = __props;
        // 送信ボタンの活性/非活性判定
        const disabled = ref(true);
        const form = InertiaUtil.getForm({
            email: '',
            // recaptcha: '',
        });
        // 文字数チェック
        watch(() => form.email, (value) => {
            if (Alert.charLimitText(value)) {
                form.email = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        const onVerify = (response) => {
            // form.recaptcha = response;
            disabled.value = false;
        };
        const onExpired = () => {
            // form.recaptcha = '';
            disabled.value = true;
        };
        const onError = () => {
            // form.recaptcha = '';
            disabled.value = true;
        };
        const onSubmit = () => {
            InertiaUtil.post(form, route('forgot_password.store'));
        };
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[3] || (_cache[3] = _createElementVNode("h2", null, "パスワード再発行", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _cache[2] || (_cache[2] = _createElementVNode("p", null, [
                                    _createTextVNode("パスワードを再発行します。"),
                                    _createElementVNode("br", { class: "sp" }),
                                    _createTextVNode("メールアドレスを入力してください。")
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(onSubmit, ["prevent"]),
                                    class: "pwd-form"
                                }, [
                                    _createElementVNode("dl", null, [
                                        _cache[1] || (_cache[1] = _createElementVNode("dt", null, "メール", -1)),
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).email) = $event)),
                                                type: "email",
                                                name: "f_mail",
                                                class: "wmax",
                                                placeholder: "例：info@sharementors.jp",
                                                autofocus: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(form).email]
                                            ]),
                                            ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.email)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(props.errors.email), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createVNode(RecaptchaForm, {
                                            class: "inner",
                                            onVerify: onVerify,
                                            onExpired: onExpired,
                                            onError: onError
                                        })
                                    ]),
                                    (props.forgot_password_success)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(props.forgot_password_success), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("button", {
                                            type: "submit",
                                            id: "submit-button",
                                            class: "b_max",
                                            disabled: disabled.value
                                        }, "パスワードを再設定", 8, _hoisted_9)
                                    ])
                                ], 32)
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
